export const SET_TYPE ='SET_TYPE';
export const SET_SHOW_TOC = 'SET_SHOW_TOC';
export const SET_SHOW_DATE = 'SET_SHOW_DATE';
